import { useRouter } from 'next/router'

import {
  isUnauthorizedProjectAccess,
  isUnauthorizedWorkspaceAccess,
} from './common'
import { UnauthorizedResult } from './UnauthorizedResult'
import { projectUrls } from '@/config/urls/project/project'
import { useWorkspaceContext } from '@/context/WorkspaceContext'
import { useHttpFetcher } from '@/utils/http'

import { PageProjectUser, Project } from '@/types/index.d'

type RouteProtectionProps = {
  children?: React.ReactNode
}

export function RouteProtection({
  children,
}: RouteProtectionProps): JSX.Element {
  const { workspace, workspaceId, user, membership } = useWorkspaceContext()
  const accountRole = user.roles.filter(
    (role) => role.workspace_id === workspaceId
  )[0].role

  const router = useRouter()
  const { repositoryId } = router.query

  const { data: project, isLoading: isProjectDataLoading } =
    useHttpFetcher<Project>({
      url: projectUrls.getProjectInfo({
        workspaceId,
        projectId: repositoryId as string,
      }),
    })

  const { data: team, isLoading: isTeamDataLoading } =
    useHttpFetcher<PageProjectUser>({
      url: projectUrls.listProjectUsers({
        workspaceId,
        projectId: repositoryId as string,
        params: { page: 0, size: 100 },
      }),
    })

  const teamMember = team?.content.find(
    (teamMember) => teamMember.user.id === user?.id
  )
  const isLoading = isProjectDataLoading || isTeamDataLoading
  const projectRole = teamMember?.role

  if (
    isUnauthorizedWorkspaceAccess({
      accountRole,
      pathname: router.pathname,
      workspace,
    }) ||
    isUnauthorizedProjectAccess({
      projectRole: projectRole,
      accountRole: membership?.role,
      pathname: router.pathname,
      project,
      isLoading,
    })
  ) {
    return <UnauthorizedResult />
  }
  return <>{children}</>
}
